module.exports = __webpack_public_path__ + "static/frontUserNew/img/template-project.14f6146a.png";